interface Props {
  color?: string
  width?: number
  height?: number
}

export const CenterAlignIcon = ({ color = '#6F6F6F', width = 21, height = 23 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.4971 0C10.7728 0.000261253 10.9968 0.224235 10.9971 0.5V6.46875H20.4922L20.5928 6.47852C20.8208 6.525 20.9922 6.72699 20.9922 6.96875V15.2012C20.9919 15.4771 20.7682 15.7012 20.4922 15.7012H10.9971V21.668C10.9971 21.9439 10.773 22.1677 10.4971 22.168C10.2209 22.168 9.99707 21.9441 9.99707 21.668V15.7012H0.5C0.224225 15.7009 0.000276064 15.4769 0 15.2012V6.96875C0 6.69275 0.224055 6.46898 0.5 6.46875H9.99707V0.5C9.99732 0.224074 10.2211 0 10.4971 0ZM10.9971 14.7012H19.9922V7.46875H10.9971V14.7012ZM1 14.7012H9.99707V7.46875H1V14.7012Z"
        fill={color}
      />
    </svg>
  )
}
